import { ModalcontainerController as Modalcontainer } from './modalcontainerController/modalcontainer.controller';

export default Modalcontainer;
